import { keepPreviousData } from '@tanstack/react-query';

import { CreativeAssetsPolicy } from '@playq/octopus2-files';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { assetsPolicy } from './constants';

export const useAssetsPolicy = (
  options?: IUseQueryOptionsExtended<CreativeAssetsPolicy | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(assetsPolicy, () => services2.appAssetsService.policy(), {
    placeholderData: keepPreviousData,
    ...options,
  });

  return {
    ...res,
    policies: res.data?.tags ?? [],
  };
};
